import React, { memo } from 'react';
import classnames from 'classnames/bind';
import styles from "../../styles.pcss";
import { getSizeWithUnits } from "../../../../utils/checkFiles";
var cn = classnames.bind(styles);
export var SizeInfo = /*#__PURE__*/memo(function (_ref) {
  var allowedTypes = _ref.allowedTypes,
    maxFileSize = _ref.maxFileSize;
  var sizeInfoText = ".".concat(allowedTypes.join(', .'), " , \u0434\u043E ").concat(getSizeWithUnits(maxFileSize, 0));
  return /*#__PURE__*/React.createElement("p", {
    className: cn('text'),
    "data-t-id": "components-SizeInfo"
  }, sizeInfoText);
});